import { Controller, useFieldArray, useWatch } from "react-hook-form";

import { CCard, CCardBody } from "@coreui/react";

import {
  CRadio,
  CRange,
  CRating,
  CSelect,
  CTextarea,
} from "src/common/components/controls";
import { CTable } from "src/common/components/others";

import { renderRating } from "../../funcs";

const mapTargetLabels = {
  financial: "Năng lực tài chính",
  reputation: "Uy tín nhà cung cấp",
  quality: "Chất lượng",
  pricing: "Giá cả",
};

export const MarkTable = ({ control, approvers = [], roleId, setRoleId }) => {
  //#region Data
  const is_approval = useWatch({ control, name: "is_approval" });
  const is_final_step = useWatch({ control, name: "is_final_step" });

  const { fields } = useFieldArray({
    control,
    name: "evaluations",
    keyName: "__id",
  });
  //#endregion

  //#region Render
  const headers = [
    { key: "percent", label: "Tiêu chí", sorter: false },
    { key: "muc_do", label: "Mức độ đánh giá", sorter: false },
    { key: "score", label: "Đánh giá", sorter: false },
    { key: "note", label: "Ghi chú", sorter: false },
  ];

  const mapColor = (_value) => {
    if (_value >= 85) return "#20A686";
    else if (_value >= 70) return "#FFB946";
    else return "#F7685B";
  };

  const render = {
    percent: ({ code }, index) => (
      <td>
        <div className="flex flex-col gap-1">
          <h5 className="font-semibold text-base text-left mb-0">
            {mapTargetLabels[code]}
          </h5>
          <Controller
            control={control}
            name={`evaluations.${index}.percent`}
            render={({ field }) => (
              <CRange
                {...field}
                fillColor={mapColor(field.value)}
                disabled={!is_approval}
              />
            )}
          />
        </div>
      </td>
    ),
    muc_do: (record, index) => (
      <td>
        <Controller
          control={control}
          name={`evaluations.${index}.percent`}
          render={({ field }) => renderRating(field.value)}
        />
      </td>
    ),
    score: (record, index) => (
      <td>
        <div className="flex w-full items-center justify-center">
          <Controller
            control={control}
            name={`evaluations.${index}.score`}
            render={({ field }) => (
              <CRating {...field} disabled={!is_approval} />
            )}
          />
        </div>
      </td>
    ),
    note: (record, index) => (
      <td>
        <Controller
          control={control}
          name={`evaluations.${index}.note`}
          render={({ field }) => (
            <CTextarea {...field} disabled={!is_approval} />
          )}
        />
      </td>
    ),
  };

  return (
    <>
      <CCard>
        <CCardBody>
          <div className="mb-3 w-80">
            <CSelect
              options={approvers ?? []}
              value={roleId}
              onChange={setRoleId}
              display="label"
              select="id"
            />
          </div>

          <CTable fields={headers} render={render} data={fields} />
        </CCardBody>
      </CCard>

      {is_approval && is_final_step && (
        <CCard>
          <CCardBody>
            <div className="flex flex-row gap-4 items-center">
              <Controller
                control={control}
                name="final_note"
                render={({ field }) => (
                  <CTextarea
                    {...field}
                    className="min-w-[350px]"
                    label="Chốt cuối cùng"
                    placeholder="Nhập ghi chú"
                  />
                )}
              />
              <div className="flex flex-row gap-1 items-center">
                <span className="text-lg font-semibold">Quyết định:</span>
                <Controller
                  control={control}
                  name="decision"
                  render={({ field }) => (
                    <CRadio
                      {...field}
                      direction="horizontal"
                      options={[
                        { id: "1", value: "1", label: "Chọn" },
                        { id: "0", value: "0", label: "Không chọn" },
                      ]}
                    />
                  )}
                />
              </div>
            </div>
          </CCardBody>
        </CCard>
      )}
    </>
  );
  //#endregion
};
